<div id="left_side_menu" class="sidenav">
  <nav>
    <ul>
      <a href="javascript:void(0)" class="closebtn" onclick="closeNav()"
        >&times;</a
      >
      <a href="/">Home</a>
    </ul>
  </nav>
</div>
<span style="font-size: 30px; cursor: pointer;" onclick="openNav()"
  >&#9776;</span
>
